// extracted by mini-css-extract-plugin
module.exports = {"Component":"Error_Component__Wwmi4","Content":"Error_Content__2611o","Status":"Error_Status__qiKvE"};